<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      v-if="device && infoAboutPU.canChangeTariff === true && !isTariffExists"
    >
      <v-divider class="divider d-flex"></v-divider>

      <h2 class="change-tariff-electricity__title-2">{{$t('pages.changeTariff.inputIndication')}}</h2>

      <em class="change-tariff-electricity__marker">
        <sup>*</sup> {{$t('requireFields')}}
      </em>

      <v-row>
        <v-col class="col col-title" :cols="5" :sm="4" :md="3" :lg="2" :xl="2">
          {{$t('pages.changeTariff.day')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
          <v-text-field
            type="number"
            v-model="day"
            :rules="dayRules"
            min="0"
            :disabled="loading"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="col col-title" :cols="5" :sm="4" :md="3" :lg="2" :xl="2">
          {{$t('pages.changeTariff.night')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
          <v-text-field
            type="number"
            v-model="night"
            :rules="nightRules"
            min="0"
            :disabled="loading"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="col col-title" :cols="5" :sm="4" :md="3" :lg="2" :xl="2">
          Сумма:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
          <v-text-field
            type="number"
            v-model="sum"
            :rules="sumRules"
            min="0"
            :disabled="loading"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <div
        class="radio-btns"
        v-if="
          infoAboutPU.waysForTransmittingReadings &&
          infoAboutPU.waysForTransmittingReadings.length > 0
        "
      >
        <h3 class="radio-btns-title">
          {{$t('pages.changeTariff.selectOptionIndications')}}:
          <sup class="star">*</sup>
        </h3>

        <v-radio-group
          v-model="wayForTransmittingReading"
          :rules="radioRules"
          :disabled="loading"
          column
        >
          <v-radio
            v-for="(
              waysForTransmittingReading, key
            ) in infoAboutPU.waysForTransmittingReadings"
            :key="key"
            :label="waysForTransmittingReading"
            :value="waysForTransmittingReading"
            color="#33cc33"
          >
          </v-radio>
        </v-radio-group>

        <span class="radio-btns-info" v-if="infoAboutPU.mkd">{{
          infoAboutPU.clarification
        }}</span>
      </div>

      <v-divider class="divider"></v-divider>

      <v-row class="row-phone">
        <v-col class="col col-title" :cols="5" :sm="4" :md="3" :lg="2" :xl="2">
          {{$t('phone')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
          <v-select
            :items="actualPhones"
            :rules="phoneRules"
            item-text="phoneNumber"
            item-value="phoneNumber"
            v-model="phone"
            :disabled="loading"
            outlined
          >
          </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="6">
          <v-btn
            @click="preview"
            class="btn btn--blue"
            :disabled="isTariffExists"
            :loading="loading"
            >{{$t('buttons.view')}}</v-btn
          >
        </v-col>
        <v-col class="text-right" :cols="6">
          <v-btn @click="clear" class="btn btn--white" :loading="loading"
            >{{$t('buttons.cancel')}}</v-btn
          >
          <v-btn
            @click="save"
            :disabled="isTariffExists"
            class="btn btn--green"
            :loading="loading"
            >{{$t('buttons.save')}}</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
    <div v-else-if="device && infoAboutPU.canChangeTariff === false && alert">
      <v-alert color="#ff5252">
        <template>
          <v-row>
            <v-col>
              <v-icon class="col-alert-icon" color="white"
                >mdi-close-circle</v-icon
              >
              <span class="col-alert-text" notAvailable
                >{{$t('pages.changeTariff.notAvailable')}}</span
              >
            </v-col>
            <v-col class="col-alert col-alert-right">
              <v-icon @click="alert = false" color="white">mdi-close</v-icon>
            </v-col>
          </v-row>
        </template>
      </v-alert>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    selectedAccount: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    alert: false,
    wayForTransmittingReading: null,
    day: null,
    night: null,
    sum: null,
    phone: null,
    valid: false,
    loading: false,
    isTariffExists: false,
    textNotification: null,
  }),
  methods: {
    validate() {
      return !!this.$refs.form.validate();
    },
    save() {
      if (!this.validate()) return false;
      this.loading = true;
      this.$store
        .dispatch(
          "statements/setApplicationForChangeTariff",
          this.getChangeTariffInfo
        )
        .then((result) => {
          this.loading = false;
          if (result.success) {
            this.clear();
          } else {
            if (
              result.message.includes(
                "Уважаемый клиент! В этом месяце вы уже подавали заявление на изменение вида тарифа на электроэнергию по данному прибору учета"
              )
            ) {
              this.isTariffExists = true;
              this.textNotification = result.message.replace(
                "Уважаемый клиент!",
                ""
              );
            }
          }
        });
    },
    preview() {
      if (!this.validate()) return false;
      this.loading = true;
      this.$store
        .dispatch(
          "statements/getApplicationForChangeTariff",
          this.getChangeTariffInfo
        )
        .then((response) => {
          this.loading = false;

          const key = Math.random() * Math.random() * Math.random();
          localStorage.setItem(key, response);

          let routeData = this.$router.resolve({
            path: "/preview",
            query: {
              title: "Заявление на смену тарифа на электроэнергию",
              key,
            },
          });

          window.open(routeData.href, "_blank");
        });
    },
    clear() {
      this.wayForTransmittingReading = null;
      this.day = null;
      this.night = null;
      this.sum = null;
      this.phone = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
  computed: {
    ...mapState("account", ["actualPhones"]),
    ...mapState("indication", {
      devices: (state) =>
        state.devices.filter(
          (i) => i.measure && i.measure.trim().toLowerCase() === "квт*час"
        ),
    }),
    ...mapState("statements", ["infoAboutPU"]),
    getChangeTariffInfo() {
      return {
        userId: this.$store.state.account.userSettings.userGuid,
        domHoz: this.selectedAccount.domHoz,
        meterNumber: this.device.meterNumber,
        wayForTransmittingReadings: this.wayForTransmittingReading,
        tariffType: this.infoAboutPU.tariffType,
        mkd: this.infoAboutPU.mkd,
        dayValue: this.day.replace(/\./, ","),
        nightValue: this.night.replace(/\./, ","),
        sum: this.sum.replace(/\./, ","),
        phone: this.phone,
      };
    },
   dayRules() {
      return [
      (v) => !!v || this.$t('rules.inputCorrectData'),
      (v) => +v >= 0 || this.$t('rules.notNegativeNumber'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    nightRules() {
      return [
      (v) => !!v || this.$t('rules.inputCorrectData'),
      (v) => +v >= 0 || this.$t('rules.notNegativeNumber'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    sumRules(){
      return [
      (v) => +v >= 0 || this.$t('rules.inputCorrectData'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    phoneRules(){ return [(v) => !!v || this.$t('rules.selectPhone')]},
    radioRules() { return [(v) => !!v || this.$t('rules.selectOption')]}
  },
};
</script>

<style lang="scss" scoped>
.change-tariff-electricity {
  width: 100%;
  position: relative;
  padding: 23px 17px 23px 22px;
  background-color: white;
  border-radius: 5px;

  &__br {
    display: block;
    font-size: 20px;
  }

  &__title {
    @extend %h1;
  }

  &__title-2 {
    color: #333333;
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 22px;
  }

  &__important {
    display: block;
    @extend %important-text;
  }

  &__text {
    display: block;
    @extend %text;
    font-style: italic;
  }

  &__marker {
    display: block;
    @extend %marker-text;
    margin-bottom: 21px;
  }

  &__form {
    position: relative;
    width: 100%;
  }
}

.btn {
  &--blue {
    @extend %b-btn;
    margin: 8px 8px 8px 0;
  }

  &--white {
    @extend %w-btn;
    margin: 8px 0 8px 8px;
  }

  &--green {
    @extend %g-btn;
    margin: 8px 0 8px 16px;
  }
}

.divider {
  background: #999;
}

.star {
  color: #ff9933;
}

.radio-btns-title,
.col col-title {
  font-weight: 500;
  font-size: 18px;
  color: #4d4d4d;
}

.radio-btns-title {
  display: block;
  margin: 25px 0;
}

.radio-btns {
  margin-bottom: 30px;
}

.radio-btns-info {
  display: block;
  @extend %marker-text;
  color: $main-orange;
  margin-top: 21px;
}

.col {
  padding: 0 12px;

  &-title {
    @extend %important-text;
    width: 300px;
    align-self: center;
    margin-bottom: 30px;
  }
}

.row-phone {
  margin: 30px 0 12px 0;
}

.v-radio {
  margin-right: 0;

  & + & {
    margin-top: 7px;
  }
}

.col-alert {
  display: flex;
  align-items: center;

  &-text {
    margin-left: 10px;
    color: white;
  }

  &-right {
    justify-content: flex-end;
  }
}
</style>